export default __webpack_public_path__ + "f83897d0adf079d6cc1305439f7c1fb7.svg";